import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Achievements from './components/Achievements';
import Gallery from './components/Gallery';
import Skills from './components/Skills';
import Sponsorship from './components/Sponsorship';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-darker min-h-screen noise-bg">
      <Navbar />
      <Hero />
      <About />
      <Achievements />
      <Gallery />
      <Skills />
      <Sponsorship />
      <Footer />
    </div>
  );
}

export default App;